import { MenuItem } from '@mui/material';
import { BaseMenuItemProps } from './BaseMenuItem.types';

/**
 * The base `MenuItem` control that wraps MUI. Used the separate MUI from our wrappers
 * so we can mock it with jest.
 *
 * @param classes - {@link BaseMenuItemProps.classes classes} description.
 * @param value - {@link BaseMenuItemProps.value value} description.
 * @param dataValue - {@link BaseMenuItemProps dataValue} description.
 * @param selected - {@link BaseMenuItemProps.selected selected} description.
 * @param ariaSelected - {@link BaseMenuItemProps ariaSelected} description.
 * @param onClick - {@link BaseMenuItemProps.onClick onClick} description.
 * @param onKeyUp - {@link BaseMenuItemProps.onKeyUp onKeyUp} description.
 * @param children - {@link BaseMenuItemProps.children children} description.
 */
export const BaseMenuItem = ({
    classes,
    value,
    'data-value': dataValue,
    selected,
    'aria-selected': ariaSelected,
    onClick,
    onKeyUp,
    children,
}: BaseMenuItemProps) => {
    return (
        <MenuItem
            role={'option'}
            classes={{
                ...classes,
            }}
            value={value}
            data-value={dataValue}
            selected={selected}
            aria-selected={ariaSelected}
            onClick={onClick}
            onKeyUp={onKeyUp}
        >
            {children}
        </MenuItem>
    );
};